import React from 'react';

const IconEyeView = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M18 10C18 10 14.4174 15 10 15C5.58261 15 2 10 2 10C2 10 5.58261 5 10 5C14.4174 5 18 10 18 10Z"
        stroke="#111111"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        fill="#111111"
      />
    </svg>
  );
};

export default IconEyeView;
